<div class="ui-datepicker w-100">
  <input
    class="lum-input"
    [disabled]="disabled"
    [placeholder]="placeholder"
    [matDatepicker]="datePicker"
    (dateChange)="onFilterChange($event.value)"
    [ngClass]="{
      error: formControl?.invalid,
    }"
    [value]="formControl?.value"
  />
  <mat-datepicker-toggle matSuffix [for]="datePicker"></mat-datepicker-toggle>
  <mat-datepicker #datePicker></mat-datepicker>
</div>
